import React, { useState } from 'react';
import AUX from '../../../hoc/Aux_';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  forgotPasswordRequest,
  forgotPasswordOTP,
} from '../../../redux/MainAction';
import Axios from 'axios';
import Constant from '../../../Constant';
import { toast } from 'react-toastify';
import { getDomainType } from '../../../Constant';
import OtpInput from 'react-otp-input';

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const [userRole, setUserRole] = useState('user');
  const [domainId, setDomainId] = useState('');

  const employees = localStorage.getItem('employee');

  const [email, setEmail] = useState('');
  const [isOtpSent, setIsOtpSent] = useState('');
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');

  const onSubmitEmail = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error('Please enter a valid email id');
    } else {
      const domainData = {
        domainName: getDomainType(),
      };

      try {
        const response = await Axios.post(
          Constant.getAPI() + `${userRole}/auth/domain/get`,
          domainData,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        if (response?.data?.data && response?.data?.data?.id) {
          const domainId = response.data.data.id;
          setDomainId(domainId);

          const paylod = {
            domainId,
            email,
          };

          dispatch(forgotPasswordRequest(paylod, userRole)).then((data) => {
            if (data?.success) {
              setIsOtpSent(true);
              toast.success(data?.message);
            }
          });
        } else {
          alert('Domain not found');
        }
      } catch (error) {
        console.error(
          'Error submitting domain:',
          error.response ? error.response.data : error.message
        );
        alert('Failed to submit the domain.');
      }
    }
  };

  const onVerifyOtp = async (e) => {
    e.preventDefault();

    if (!otp || otp?.length < 6) {
      toast.error('Please enter a valid otp');
    } else if (!password || password?.length < 6) {
      toast.error('Password should be at least 6 characters long');
    } else {
      try {
        const payload = {
          domainId,
          email,
          otp,
          password,
        };
        dispatch(forgotPasswordOTP(payload, userRole));
      } catch (error) {
        console.error(
          'Error submitting domain:',
          error.response ? error.response.data : error.message
        );
        alert('Failed to submit the domain.');
      }
    }
  };

  return (
    <AUX>
      <div
        className="accountbg"
        style={{
          background: "url('assets/images/stardust.png')",
          backgroundSize: 'cover',
        }}
      ></div>
      <div className="wrapper-page">
        <div className="card">
          <div className="card-body">
            <h3 className="text-center m-0">
              <Link to="/" className="logo logo-admin">
                <img src="/assets/images/logo.webp" height="30" alt="logo" />
              </Link>
            </h3>

            <div className="p-3">
              <h4 className="font-18 m-b-5 text-center">Reset Password</h4>

              <form className="form-horizontal m-t-30" action="/">
                {isOtpSent ? (
                  <>
                    <div className="form-group">
                      <label for="forgotPasswordPassword">Enter OTP</label>
                      <OtpInput
                        containerStyle="otp-input-class"
                        value={otp}
                        onChange={setOtp}
                        numInputs={6}
                        renderSeparator={<span>●</span>}
                        renderInput={(props) => <input {...props} />}
                        inputType="number"
                        inputStyle={{
                          width: '100%',
                          height: '40px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.25rem',
                        }}
                      />
                    </div>

                    <div className="form-group">
                      <label for="forgotPasswordPassword">Password</label>
                      <input
                        type="password"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="form-control"
                        id="forgotPasswordPassword"
                        placeholder="Enter password"
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="form-group">
                      <label for="forgotPasswordEmail">Email</label>
                      <input
                        type="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="form-control"
                        id="forgotPasswordEmail"
                        placeholder="Enter email"
                      />
                    </div>
                    <div className="form-group">
                      <label for="forgotPasswordRoleType">Select Role</label>
                      <select
                        className="form-control"
                        id="forgotPasswordRoleType"
                        value={userRole}
                        onChange={(e) => setUserRole(e.target.value)}
                      >
                        <option value="user">Admin</option>
                        <option value="employeeWeb">Employee</option>
                      </select>
                    </div>
                  </>
                )}

                <div className="mt-4">
                  <button
                    onClick={isOtpSent ? onVerifyOtp : onSubmitEmail}
                    className="btn btn-primary w-md waves-effect waves-light w-100"
                    type="submit"
                  >
                    {isOtpSent ? 'Verify OTP' : 'Get OTP'}
                  </button>
                </div>

                <div className="mt-2">
                  <button
                    type="button"
                    onClick={() => isOtpSent && setIsOtpSent(false)}
                    className="btn btn-secondary w-md waves-effect waves-light w-100"
                  >
                    {isOtpSent ? (
                      'Change Email Id'
                    ) : (
                      <Link to="/" className="text-white">
                        Back to Login
                      </Link>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="m-t-40 text-center">
          <p className="text-white">
            © {new Date().getFullYear() - 1} - {new Date().getFullYear()} Web
            Tracker
          </p>
        </div>
      </div>
    </AUX>
  );
};

export default ForgotPassword;
